//
import Model from '@/models/ExtendModel'

/**
 * This class describes a wh product service indicator.
 *
 * @class      WhProductServiceIndicator (name)
 */
export default class WhProductServiceIndicator extends Model {
	/**
	 * enpoint location
	 *
	 * @return     {string}  enpoint name
	 */
    resource() {
        return 'wh_product_service_indicator'
    }
}